<template>
  <div
    v-if="appearance"
    class="price-update-date d-flex w-100"
    :class="[
      isMobile ? 'justify-start' : 'justify-end',
      { 'price-update-date--v5': ff_lpu_branding_page_v5 },
    ]"
  >
    <div
      class="price-update-date__text text-caption"
      :class="{
        'price-update-date__text--fresh': appearance.tone === 'fresh',
        'price-update-date__text--stale': appearance.tone === 'stale',
        'price-update-date__text--outdated': appearance.tone === 'outdated',
      }"
      data-qa="lpu_services_service_date_updated_text"
    >
      {{ appearance.text }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import formatPriceUpdateText from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/functions/formatPriceUpdateText'
import type { PriceListUpdateData } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/types'

const props = defineProps<{
  data?: PriceListUpdateData
}>()

const { context }: CommonContextStore = useContextStore()
const ff_lpu_branding_page_v5 = computed(() => (
  Boolean(context.request.feature_flags.ff_lpu_branding_page_v5)
))
const isMobile = useIsMobile()
const appearance = computed(() => formatPriceUpdateText(
  props.data?.date,
  Number(props.data?.status || 0),
))
</script>

<style scoped lang="scss">
@import 'src/styles/variables';

.price-update-date {
  &__text {
    padding: 4px 8px;
    border-radius: $border-radius-sm;
  }

  &__text--fresh {
    background-color: color-mix(in sRGB, var(--lpu-branding-color-primary) 20%, transparent);
    color: var(--lpu-branding-color-primary);
  }

  &--v5 &__text--fresh {
    color: var(--lpu-branding-color-text);
  }

  &__text--stale {
    background-color: $ui-kit-bg-warning;
    color: $ui-kit-text-warning;
  }

  &__text--outdated {
    background-color: $ui-kit-bg-error;
    color: $ui-kit-text-error;
  }
}
</style>
